<template>
	<div>
		<Header />
		<div class="fillin_banner payPage"
			:style="{'background':'url('+setImg('guzhi/payBanner','jpg')+') center center no-repeat'}">
			<div>
				<p>数据产品设计</p>
			</div>
		</div>
		<div class="mainContent">
			<div v-if="records.length>0">
				<ul class="boxhead">
					<li style="width: 22%;">公司名称</li>
					<li style="width: 25%;">所属行业</li>
					<li style="width: 25%;">数据产品名称</li>
					<li style="width: 10%;">创建时间</li>
					<li style="width: 18%;">操作</li>
				</ul>

				<ul class="dataList">
					<li v-for="(item,index) in records" :key="index">
						<div style="width: 22%;">{{item.companyName}}</div>
						<div style="width: 25%;">{{item.industry}}</div>
						<div style="width: 25%;">{{item.productName}}</div>
						<div style="width: 10%;">{{item.createTime.split(' ')[0]}}</div>
						<div style="width: 18%;">
							<router-link tag="button" class="examine"
								:to="{ path: '/dataProductDesign', query: { id:item.id,details:1 } }">
								查看详情
							</router-link>
							<button class="del" @click="delItem(item.id)">删除</button>
						</div>
					</li>
				</ul>

				<Page :current="currentPageNumber" :total="total" :page-size="pageSize" prev-text="上一页" next-text="下一页"
					@on-change="pageChange" />

			</div>

			<div v-else class="nothing">
				<img :src="setImg('nothing','png')" alt="暂无信息" />
				<p>暂无信息</p>
			</div>

		</div>


		<Modal v-model="myAlert" class-name="vertical-center-modal del" @on-ok="ok()">
			<img class='warning' src="../../assets/img/remind-01@2x.png">
			<div>
				<p>确定要删除吗？</p>
				<p>删除后无法恢复这条记录</p>
			</div>
		</Modal>


		<SignUp />
		<Footer />
	</div>
</template>

<script>
	import Header from '../../common/header/flow_header.vue'
	import Footer from '../../common/footer.vue'
	import publicMethod from '../publicMethod'
	import SignUp from '@/components/signUp/index.vue'
	import tsconfig from '@/assets/js/tsconfig.json';

	import '../myCenter/personalCenter.less'

	import qs from 'qs'

	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer,
			SignUp
		},
		data() {
			return {
				url: this.domain.testUrl + this.domain.valuationProject,
				myAlert: false,
				delId: '',
				currentPageNumber: 1, //当前页码
				total: 0, //总页数
				pageSize: 4, //每页条数
				records: [],
				keyWord: ''

			}
		},
		mounted() {
			this.getDataDesignList(1)
		},
		methods: {
			pageChange(data) { //切换页数
				console.log(data)
				this.currentPageNumber = data
				this.getDataDesignList(data)
			},
			getDataDesignList(pageNum) {
				this.$post(this.url + 'dataProductDesign/getDataDesignList', qs.stringify({
						pageNum: pageNum,
						pageSize: this.pageSize,
						keyWord: this.keyWord,
					}))
					.then((res) => {
						this.records = res.data.content.records
						this.total = res.data.content.total
					});

			},
			delItem(id) {
				this.myAlert = true
				this.delId = id
			},
			ok() {
				this.$post(this.url + 'dataProductDesign/delDataDesignDetail', qs.stringify({
						designId: this.delId
					}))
					.then((res) => {
						this.myAlert = false
						this.getDataDesignList(1)
					});

			}



		}


	}
</script>

<style scoped>
	.del {
		background: #B3B3B3;
	}
</style>